import * as React from "react";

const SvgInfo = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path data-name="Path 8402" d="M11 2a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 13.5a.9.9 0 0 1-.9-.9V11a.9.9 0 0 1 1.8 0v3.6a.9.9 0 0 1-.9.9zm.9-7.2h-1.8V6.5h1.8z" transform="translate(-2 -2)" style={{
    fill: "currentColor"
  }} /></svg>;

export default SvgInfo;